import { CarouselItem } from './types.type';

export const bannerTexts: CarouselItem[] = [
  {
    text: 'Algo Strategies',
    colorClass: 'blue',
    icon: '/banner-icon-1.svg',
  },
  {
    text: 'Try Backtesting',
    colorClass: 'red',
    icon: '/banner-icon-2.svg',
  },
  {
    text: 'No-code Setups',
    colorClass: 'yellow',
    icon: '/banner-icon-3.svg',
  },
];
